module.exports = "/lucky-balls/img/infobox/info_Box_019.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_019.png
// module id = 1084
// module chunks = 0